import React from "react";

export default function Step11() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          11
        </div>
        <div className="">
          Ao preencher os dados, apenas atente-se que:
          <p className="mt-1 font-semibold">
            O CEP deve ser informado no formato 00000-000
          </p>
          <p className="mt-1 font-semibold">
            E o CPF deve ser informado no formato 000.000.000-00.
          </p>
        </div>
      </div>
      <div className="mt-2.5 ml-[42px] flex items-start gap-2.5 sm:gap-5 flex-wrap">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3621%20(1).jpg?alt=media&token=f6e683f1-03c2-4afd-9085-c6f78174ee2b"
          className="w-72"
          alt=""
        />
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3630.jpg?alt=media&token=b0096237-bf67-43dc-b2a1-c3a68bcf4714"
          className="w-72"
        />
      </div>
    </div>
  );
}
